import {
  Button,
  Col,
  Create,
  Row,
  SaveButton,
  useForm,
  useSelect,
} from "@pankod/refine-antd";
import {
  IResourceComponentsProps,
  useMutation,
  useNavigation,
  useNotification,
} from "@pankod/refine-core";
import {
  IShootExecutionForm,
  ShootExecutionForm,
} from "components/forms/frm_shootexecution";
import { FC } from "react";
import { uploadExecutionFile } from "services/shoot-execution";
import { extractApiErrorMessage } from "utils/utils";

export const ShootExecutionCreate: FC<IResourceComponentsProps> = () => {
  const { goBack, replace } = useNavigation();
  const { open } = useNotification();

  const {
    selectProps: campaignSelectProps,
    queryResult: { data: campaigns },
  } = useSelect({
    resource: "v1/repique-campaign",
    optionLabel: "name",
    optionValue: "_id",
  });

  const { formProps, saveButtonProps, queryResult, onFinish } = useForm({
    redirect: false,
    successNotification: false,
    errorNotification: false,
    onMutationError: (error) => {
      const message = extractApiErrorMessage(error);
      open?.({
        type: "error",
        description: "Erro ao criar disparo!",
        message,
      });
    },
  });

  const { mutate: uploadFile, isLoading: isUploading } = useMutation({
    mutationFn: uploadExecutionFile,
  });

  const handleFinish = async (values: IShootExecutionForm) => {
    const templates_schedule = values.templates_schedule.map(
      ({ scheduled_datetime, order }) => {
        return {
          order,
          scheduled_datetime: scheduled_datetime.format(
            "YYYY-MM-DDTHH:mm:ss-03:00"
          ),
        };
      }
    );

    const firstTemplate = templates_schedule.reduce((prev, curr) => {
      if (prev.order < curr.order) {
        return prev;
      }
      return curr;
    });

    if (!firstTemplate) return;

    const payload = {
      active: true,
      campaign_id: values.campaign_id,
      templates_schedule,
      rate_per_minute: values.rate_per_minute,
      negative_cycle_days: values.negative_cycle_days,
    };
    const createResponse = await onFinish?.(payload);
    const newId = createResponse?.data?._id;

    if (!newId) return;

    uploadFile(
      {
        file: values.leads_file,
        shootId: newId,
      },
      {
        onSuccess: () => {
          open?.({
            type: "success",
            message: "Disparo agendado com sucesso",
          });

          replace(`/engaging/campaign-executions/edit/${newId}`);
        },
        onError: (error: any) => {
          const message = extractApiErrorMessage(error);

          open?.({
            type: "error",
            message,
          });

          replace(`/engaging/campaign-executions/edit/${newId}`);
        },
      }
    );
  };

  return (
    <Create
      title="Novo Disparo"
      footerButtons={() => (
        <Row gutter={[6, 6]}>
          <Col>
            <Button onClick={() => goBack()} style={{ minWidth: "92px" }}>
              Cancelar
            </Button>
          </Col>

          <Col>
            <SaveButton
              {...saveButtonProps}
              icon={null}
              style={{ minWidth: "92px" }}
            >
              Salvar
            </SaveButton>
          </Col>

          <Col>
            <Button className="execute-btn" disabled>
              Executar Disparo
            </Button>
          </Col>
        </Row>
      )}
    >
      <ShootExecutionForm
        formProps={{
          ...formProps,
          onFinish: handleFinish,
        }}
        queryResult={queryResult}
        campaignSelectProps={campaignSelectProps}
        campaigns={campaigns?.data}
        formLoading={isUploading}
      />
    </Create>
  );
};
